import { FlightPurchaseModel } from 'api-hooks/order/ticket-order';
import { TicketSaleModel } from 'api-hooks/sale/ticket-sale';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

export const TicketOrderFlightPurchaseGuestFormSchema = () =>
  Yup.object({
    guestId: Yup.string().default(''),
    ticket: Yup.string().default(''),

    //additional information
    guestName: Yup.string().default(''),
    customId: Yup.string(),
  });

export const TicketOrderFlightPurchaseAirlineFormSchema = () =>
  Yup.object({
    airlineId: Yup.string().default(''),
    date: Yup.date().default(new Date()),
    detail: Yup.string().default(''),
    preferenceId: Yup.string().default(''),
    route: Yup.string().default(''),
    time: Yup.string().default(''),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),

    //additional information
    airlineName: Yup.string().default(''),
    preferenceName: Yup.string().default(''),
    customId: Yup.string(),
  });

export const TicketOrderFlightPurchaseAddOnsFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    guestId: Yup.string().default(''),
    route: Yup.string().default(''),
    description: Yup.string().default(''),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),

    //additional information
    guestName: Yup.string().default(''),
    customId: Yup.string(),
  });

export const TicketOrderFlightPurchaseFormSchema = () =>
  Yup.object({
    bookingCode: Yup.string().default(''),
    flightPurchaseGuests: Yup.array(
      TicketOrderFlightPurchaseGuestFormSchema(),
    ).default([]),
    flightPurchaseAirlines: Yup.array(
      TicketOrderFlightPurchaseAirlineFormSchema(),
    ).default([]),
    flightPurchaseAddOns: Yup.array(
      TicketOrderFlightPurchaseAddOnsFormSchema(),
    ).default([]),

    //additional information
    customId: Yup.string(),
  });

export const TicketOrderFormSchema = () =>
  Yup.object({
    refId: Yup.string(),
    parentRefId: Yup.string(),
    code: Yup.string().default(''),
    description: Yup.string().default(''),
    type: Yup.string().default(''),
    transactionAt: Yup.date().default(new Date()),
    needApproval: Yup.boolean().default(false),
    tourRefId: Yup.string(),
    invoiceRefId: Yup.string(),
    agentId: Yup.string().default(''),
    paymentChannelId: Yup.string().default(''),
    discount: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    otherCost: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    total: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    commission: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    flightPurchases: Yup.array(TicketOrderFlightPurchaseFormSchema()).default(
      [],
    ),
  });

export type MainAdditionalFormType = {
  tempTransactionAt: Date;
  invoiceId: string | undefined;
  tourId: string | undefined;
  agentStatus: string;
  saleTotal: number;
  orderNumber: string;
  remainingTransactionQuota: number | null;
  isExceedingQuota: boolean;
};

export type TicketOrderFormType = Yup.InferType<
  ReturnType<typeof TicketOrderFormSchema>
> &
  MainAdditionalFormType & {
    flightSale?: TicketSaleModel;
    flightPurchase?: FlightPurchaseModel;
  };

export type TicketOrderMethodType = ReturnType<
  typeof useForm<TicketOrderFormType>
>;

export type TicketOrderFlightPurchaseFormType = Yup.InferType<
  ReturnType<typeof TicketOrderFlightPurchaseFormSchema>
>;

export type TicketOrderFlightPurchaseAddOnsFormType = Yup.InferType<
  ReturnType<typeof TicketOrderFlightPurchaseAddOnsFormSchema>
>;

export type TicketOrderFlightPurchaseAirlineFormType = Yup.InferType<
  ReturnType<typeof TicketOrderFlightPurchaseAirlineFormSchema>
>;

export type TicketOrderFlightPurchaseGuestFormType = Yup.InferType<
  ReturnType<typeof TicketOrderFlightPurchaseGuestFormSchema>
>;
